"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortDateDatasets = exports.preselectDateDataset = exports.transform2Dropdown = exports.getRecommendedDateDataset = exports.unrelatedHeader = exports.relatedHeader = exports.otherHeader = exports.recommendedHeader = exports.isDateDatasetHeader = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var groupBy_1 = tslib_1.__importDefault(require("lodash/groupBy"));
var takeWhile_1 = tslib_1.__importDefault(require("lodash/takeWhile"));
var first_1 = tslib_1.__importDefault(require("lodash/first"));
/**
 * @internal
 */
exports.isDateDatasetHeader = function (obj) {
    return obj && obj.type === "header";
};
function hasSameRelevance(dateDatasets) {
    var relevanceCount = Object.keys(groupBy_1.default(dateDatasets, "relevance")).length;
    return relevanceCount === 1;
}
var relevanceComparator = function (a, b) { return b.relevance - a.relevance; }; // descending sort
var titleComparator = function (a, b) {
    return a.title.localeCompare(b.title);
};
function sortByTitle(dateDatasets) {
    return dateDatasets.slice().sort(titleComparator);
}
function sortByRelevanceAndTitle(dateDatasets) {
    return dateDatasets.slice().sort(function (a, b) {
        if (a.relevance === b.relevance) {
            return titleComparator(a, b);
        }
        return relevanceComparator(a, b);
    });
}
var MAX_RECOMMENDED_ITEMS = 3;
/**
 * @internal
 */
exports.recommendedHeader = {
    title: "gs.date.date-dataset.recommended",
    type: "header",
};
/**
 * @internal
 */
exports.otherHeader = {
    title: "gs.date.date-dataset.other",
    type: "header",
};
/**
 * @internal
 */
exports.relatedHeader = {
    title: "gs.date.date-dataset.related",
    type: "header",
};
/**
 * @internal
 */
exports.unrelatedHeader = {
    title: "gs.date.date-dataset.unrelated",
    type: "header",
};
function addUnrelatedDateDataset(dateDatasets, unrelatedDateDataset) {
    if (hasSameRelevance(dateDatasets)) {
        return tslib_1.__spread([exports.unrelatedHeader, unrelatedDateDataset, exports.relatedHeader], dateDatasets);
    }
    return tslib_1.__spread([exports.unrelatedHeader, unrelatedDateDataset], dateDatasets);
}
/**
 * @internal
 */
function getRecommendedDateDataset(items) {
    if (hasSameRelevance(items)) {
        return null;
    }
    return first_1.default(sortByRelevanceAndTitle(items));
}
exports.getRecommendedDateDataset = getRecommendedDateDataset;
/**
 * @internal
 */
function transform2Dropdown(dateDatasets) {
    if (!dateDatasets.length) {
        return [];
    }
    var items = sortByRelevanceAndTitle(dateDatasets);
    if (!hasSameRelevance(items)) {
        var nonZeroRelevanceItemsCount = takeWhile_1.default(items, function (i) { return i.relevance > 0; }).length;
        var othersIndex = Math.min(MAX_RECOMMENDED_ITEMS, nonZeroRelevanceItemsCount);
        var recommendedItems = tslib_1.__spread([exports.recommendedHeader], items.slice(0, othersIndex));
        if (othersIndex < items.length) {
            return tslib_1.__spread(recommendedItems, [exports.otherHeader], sortByTitle(items.slice(othersIndex)));
        }
        return recommendedItems;
    }
    return sortByTitle(items);
}
exports.transform2Dropdown = transform2Dropdown;
function getRecommendedItems(recommendedDate, others) {
    return tslib_1.__spread([exports.recommendedHeader, recommendedDate, exports.otherHeader], sortByTitle(others));
}
/**
 * @internal
 */
function preselectDateDataset(dateDatasets, recommendedDate) {
    var others = dateDatasets.filter(function (d) { return d.id !== recommendedDate.id; });
    if (others.length > 0) {
        return getRecommendedItems(recommendedDate, others);
    }
    return [recommendedDate];
}
exports.preselectDateDataset = preselectDateDataset;
/**
 * @internal
 */
function sortDateDatasets(dateDatasets, recommendedDate, unrelatedDate) {
    if (recommendedDate === void 0) { recommendedDate = null; }
    if (unrelatedDate === void 0) { unrelatedDate = null; }
    var items = recommendedDate
        ? preselectDateDataset(dateDatasets, recommendedDate)
        : transform2Dropdown(dateDatasets);
    if (unrelatedDate) {
        items = addUnrelatedDateDataset(items, unrelatedDate);
    }
    return items;
}
exports.sortDateDatasets = sortDateDatasets;
//# sourceMappingURL=dateDatasets.js.map